import React from "react";
import { Container, LogoImg } from "./styles";

const Logo = ({ src }) => (
  <Container>
    <LogoImg src={src} alt="header-logo" />
  </Container>
);

export default Logo;
